{
  "title": "Users",
  "user": "User",
  "firstName": "First Name",
  "lastName": "Last Name",
  "middleName": "Middle Name",
  "email": "Email",
  "homeNumber": "Home Number",
  "mobileNumber": "Mobile Number",
  "role": "Role",
  "users-create-title": "Create User",
  "created": "Created User",
  "add-user": "Add User",
  "create-user-description": "To create a new user please fill the next information. We will send an invitation for this person.",
  "invite-user-description": "To invite a new user to this order, please fill the next information. We will send an invitation for this person.",
  "send-invitation": "Send Invitation",
  "invite-user": "Invite User",
  "add-party": "add Party",
  "personal-info": "Personal Info",
  "contact-information": "Contact Information",
  "delete-user": "Delete User",
  "are-you-delete": "Are you sure you want to ",
  "delete": "Delete",
  "this-person": "this party?",
  "once-you-delete": "Once you delete this account, there’s no getting it back. Make sure you want to do this.",
  "yes-delete-it": "Yes, delete it",
  "confirm-by-tipping": "Confirm by typing",
  "sending-invite": "sending Invitation...",
  "updating-user": "updating user...",
  "getting-user": "getting user...",
  "user-opened-orders": "Opened Orders",
  "see-all-orders": "See All",
  "agent-job": "Agent job",
  "void-licenses": "No licenses added yet",
  "marketer": "Marketer",
  "legal": "Legal",
  "escrow_officer": "Escrow Officer",
  "funder": "Funder",
  "assistant": "Assistant",
  "accounting": "Accounting",
  "policy_production": "Policy production",
  "gender": "Gender",
  "marital-status": "Marital Status",
  "date-of-birth": "Date of Birth",
  "work-number": "Work Number",
  "profile": "Profile",
  "log-out": "Log out",
  "examiner": "Examiner",
  "general-information": "General Information",
  "personal-information": "Personal Information",
  "addresses": "Addresses",
  "address": "Address",
  "state": "State",
  "zip-code": "Zip Code",
  "kind": "Kind",
  "phone-number": "Phone Number",
  "licenses": "Licenses",
  "member-of": "Member Of",
  "members": "Members",
  "name": "Name",
  "see-party": "See Party",
  "users": "Users",
  "login": "Login",
  "personal": "Personal",
  "work": "Work",
  "create-user": "Create User",
  "edit-user": "Edit User",
  "create-user-success": "User created successfully",
  "create-user-error": "There was an error on the creation of the user",
  "invite-warning": "If you want to invite this user to the system, enter an email address below",
  "invite-success": "The invitation was delivered successfully",
  "invite-error": "The invitation was not successful, you can try again later",
  "no-addresses": "There are no previous addresses, you can create a new one here",
  "no-emails": "There are no previous emails, you can create a new one here",
  "no-phones": "There are no previous phones, you can create a new one here",
  "no-licenses": "There are no previous licenses, you can create a new one here",
  "no-parties": "There are no parties linked to this user",
  "no-members": "There are no members linked to this user",
  "no-payments": "There are no previous payments, you can create a new one here",
  "create-address": "Create Address",
  "create-email": "Create Email",
  "create-phone": "Create Phone",
  "create-license": "Create License",
  "create-party": "Create Party",
  "create-payment": "Create Payment",
  "create": "Create",
  "add-new": "Add New",
  "contacts": "Contacts",
  "create-new": "You can create a new contact if the one you are looking for is not found",
  "search-parties-orgs": "Search Existing Party and Organizations",
  "placeholder-search-parties-orgs": "Search Organizations / Parties",
  "create-com": "Create company",
  "create-org": "Create organization",
  "create-com-label": "Create companies to link users",
  "create-party-label": "Invite a new party",
  "create-org-label": "Create an organization",
  "user-system": "User System",
  "phones": "Phones",
  "no-matching-data": "No matching data",
  "user-is-going-to-be-invited": "The user is going to be invited to the system from this email address",
  "person": "Person",
  "company": "Company",
  "organization": "Organization",
  "invite": "Invite",
  "orders": "Orders",
  "parties": "Parties",
  "configuration": "Configuration",
  "receive-all-notifications": "Receive all notifications",
  "unlink": "Unlink",
  "error-unlinking-user": "Error Unlinking User",
  "error-deleting-user": "Error Deleting User",
  "create-order-only-title-employee": "Contact an admin to be able to create new orders",
  "dialog-confirm-label": "Type ${} to confirm",
  "dialog-unlink-title": "Do you want to unlink the following user from title platform?",
  "dialog-unlink-description": "If you unlink this user from the platform, the user will not be able to access it again, unless that user is granted access again manually",
  "dialog-unlink-confirm-button": "Unlink user from platform",
  "dialog-delete-title": "Are you sure you want to delete this user?",
  "dialog-delete-description": "Once you delete this account, there's no getting it back. Make sure you want to do this.",
  "dialog-delete-confirm-button": "Delete user from platform",
  "payments": "Payments",
  "account": "Account",
  "partyId": "Party ID",
  "routing": "Routing",
  "reference": "Reference",
  "order-transfer": "Order transfer",
  "for_benefit_of": "For benefit of",
  "country": "Country",
  "bank": "Bank",
  "bank-address": "Bank Address",
  "sorry": "Sorry",
  "you-dont-have-access": "You dont have access to this screen",
  "contact-to-the-admin": "Contact with the Administrator to get more information",
  "referencias": "References",
  "locality": "Locality",
  "settlement": "Settlement",
  "user-linked-success": "The user was linked successfully",
  "user-unlinked-success": "The user was unlinked successfully",
  "wire-transfers": "Wire Transfers",
  "create-contact":"Create Contact",
  "removeMemberTitle": "Remove Member",
  "removeMemberConfirmation": "Are you sure you want to remove the member?",
  "removeButton": "Remove",
  "newInfoAvailableMessage": "New information is available, do you want to reload?",
  "reloadButton": "Reload",
  "createButton": "Create",
  "addNewButton": "Add New",
  "deleteWireTransferTitle": "Delete Wire Transfer",
  "deleteWireTransferConfirmation": "Are you sure you want to delete the wire transfer?",
  "ssn-atin-itin-ptin": "SSN/ATIN/ITIN/PTIN",
  "ein": "EIN",
  "password-recovery-title": "Send password recovery instructions",
  "password-recovery-description": "Instructions will be sent to {{email}} when you click Send. No changes will be made until the recipient follows the steps in that email.",
  "password-recovery-send": "Send"
}
